module.exports = __webpack_public_path__ + "media/images/green note-69a608a0afe71c19e89c72eaedb78e28.svg";